import tw from "twin.macro"
import styled from "@emotion/styled/macro"

import { StyledLink } from "../../Styled/Button"
import { StyledRow } from "../../Styled/Row"
import { P } from "../../Styled/Text"

export const Trigger = tw(
  StyledLink
)`flex items-center justify-between text-grey-dark font-sans uppercase text-xxs tracking-loose md:hidden bg-grey-border text-left py-4 px-5 w-full`
export const Navigation = styled.nav`
  ${tw`relative bg-grey-lighter text-left mb-12 md:mb-0 md:py-6 md:pl-6 md:-mt-32`}
  ${({ active }) => active && tw`pb-7`}
`
export const Button = tw(
  StyledRow
)`w-full border-b border-grey-border last:border-b-0 py-4 px-5 md:pr-6 md:pl-0 text-navy hover:text-teal-dark focus:outline-none transition-colors duration-200`
export const ButtonText = tw(P)`text-sm md:text-base`
export const Menu = styled.div`
  ${tw`hidden md:block`}
  ${({ active }) => active && tw`block`}
`
export const IconWrapper = styled.div`
  ${tw`transition-all duration-200 transform`}
  ${({ active }) => active && tw`rotate-180`}
`
export const Items = tw.ul``
export const Item = styled.li`
  ${tw`block border-b border-grey-border last:border-b-0`}
  ${({ active }) => (active ? tw`bg-navy text-white hover:text-white` : tw`text-navy hover:text-teal-dark`)}
`
export const Link = styled(StyledLink)`
  ${tw`font-normal text-xms md:text-sm leading-tight flex items-center justify-start text-left py-4 pl-7 md:pl-3 pr-10`}
  ${({ active }) => active && tw`text-white`}
`
